import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import billsList from './modules/billsList';
import project from './modules/project';
import projectsList from './modules/projectsList';
import routeQuery from './modules/routeQuery';
import servicesList from './modules/servicesList';
import tagsList from './modules/tagsList';
import user from './modules/user';
import usersList from './modules/usersList';
import versionsList from './modules/versionsList';
import serviceProviders from './modules/serviceProviders';
import logsList from "./modules/logsList";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    routeQuery,
    projectsList,
    usersList,
    billsList,
    servicesList,
    tagsList,
    versionsList,
    project,
    user,
    serviceProviders,
    logsList,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});


// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js